<template>
  <BaseTableView
    :head="tableHead"
    list-view="mdAndUp"
    :class="$vuetify.breakpoint.mdAndUp ? 'table' : ''"
  >
    <template v-for="(item, key) in extra">
      <tr
        :key="'extra_' + key"
        :class="{ pointer: hasSelectedBlock(item) }"
        @click="onToggleExtraBlock(key, item)"
      >
        <td>
          <span v-if="hasSelectedBlock(item)" class="work-arrow">
            <v-icon size="16" :class="{ 'work-arrow--open': isExtraBlockOpened(key) }">
              mdi-chevron-down
            </v-icon>
          </span>
          {{ item.name }}
        </td>
        <td>{{ $formatTime(item.hours) }}</td>
      </tr>
      <tr
        v-if="hasSelectedBlock(item) && isExtraBlockOpened(key)"
        :key="'extra_block_' + key"
        class="block-row"
      >
        <td colspan="2" class="block-row__cell">
          <div class="block-subtable-wrap">
            <table class="block-subtable">
              <thead>
                <tr>
                  <th>Block</th>
                  <th>Date</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(blockItem, blockItemIndex) in item.selected_block"
                  :key="'extra_block_' + key + '_item_' + blockItemIndex"
                >
                  <td>{{ blockItem.block || '—' }}</td>
                  <td>{{ blockItem.date ? $formatDate(blockItem.date) : '—' }}</td>
                  <td>{{ formatBlockValue(blockItem.value) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </template>
    <tr class="all fw700">
      <td>{{ localStorage.translations.pages.common.text['total'] }}</td>
      <td>{{ allTime }}</td>
    </tr>
  </BaseTableView>
</template>

<script>
export default {
  name: 'TimeControlShowEmployeeTableAllTime',
  props: ['extra', 'allTime'],
  data() {
    return {
      openedBlocks: {},
    }
  },
  computed: {
    tableHead() {
      return [
        { text: this.localStorage.translations.pages.statistic_employee.tables['dopolnitelnaya-rabota'] },
        { text: this.localStorage.translations.pages.statistic_employee.tables['chasy'] },
      ]
    },
  },
  methods: {
    hasSelectedBlock(item) {
      return !!(item && Array.isArray(item.selected_block) && item.selected_block.length)
    },
    isExtraBlockOpened(index) {
      return !!this.openedBlocks[index]
    },
    onToggleExtraBlock(index, item) {
      if (!this.hasSelectedBlock(item)) return
      this.$set(this.openedBlocks, index, !this.openedBlocks[index])
    },
    formatBlockValue(value) {
      if (value === null || value === undefined || value === '') return '—'
      return this.$formatTime(this.$roundNumberToTenths(value))
    },
  },
}
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.work-arrow {
  display: inline-flex;
  margin-right: 6px;

  :deep(.v-icon) {
    transition: transform 0.2s ease;
  }

  &--open {
    transform: rotate(180deg);
  }
}

.block-row {
  background: #f6fbff;

  td {
    width: 100% !important;
    max-width: none !important;
  }

  &__cell {
    color: #5e6a73 !important;
    font-size: 13px;
    padding: 8px 16px 10px 26px !important;
    box-sizing: border-box;
  }
}

:deep(.table_tile_view > tbody > tr.block-row),
:deep(.table_card_view > tbody > tr.block-row) {
  display: block !important;
  width: 100% !important;
  background: #f6fbff !important;
}

:deep(.table_tile_view > tbody > tr.block-row:hover),
:deep(.table_card_view > tbody > tr.block-row:hover) {
  background: #f6fbff !important;
}

:deep(.table_tile_view > tbody > tr.block-row > td),
:deep(.table_card_view > tbody > tr.block-row > td) {
  display: block !important;
  width: 100% !important;
  max-width: none !important;
  border-bottom: none !important;
}

:deep(.table_tile_view > tbody > tr.block-row > td:before),
:deep(.table_card_view > tbody > tr.block-row > td:before) {
  content: none !important;
  display: none !important;
}

.block-subtable {
  width: 100%;
  min-width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    text-align: left;
    padding: 6px 10px;
    border-bottom: 1px solid #e4edf2;
  }

  th {
    font-weight: 600;
    color: #5e6a73;
  }
}

.block-subtable-wrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 960px) {
  .block-row {
    &__cell {
      padding: 8px 10px !important;
    }
  }

  .block-subtable {
    min-width: 100%;

    th,
    td {
      padding: 6px 8px;
      font-size: 12px;
      word-break: break-word;
    }
  }
}
</style>
